<template>
  <div class="ai-suggestions-container mt-4">
    <!-- Suggestions Chips -->
    <div v-if="suggestions && suggestions.length > 0" class="ai-summary-suggestions">
      <div class="d-flex flex-column align-end mb-3 ga-2">
        <v-chip
          v-for="(suggestion, index) in suggestions"
          :key="index"
          variant="outlined"
          size="small"
          class="ai-summary-suggestion-chip"
          @click="handleClick(suggestion.text)"
        >
          <span class="body3">{{ suggestion.text }}</span>
        </v-chip>
      </div>
    </div>

    <!-- Refresh Button -->
    <div v-if="!loading" class="d-flex justify-end mb-4">
      <v-btn
        variant="text"
        size="small"
        @click="onRefresh"
        :loading="refreshing"
        class="ai-summary-refresh-btn"
      >
        <v-icon size="16" icon="$refresh" class="mr-1" />
        <span class="body3 coro-link">{{ $t("aiAssistant.refreshPrompts") }}</span>
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import type { AiAssistantSuggestion } from "@/_store/ai-assistant.module";

export default defineComponent({
  props: {
    suggestions: {
      type: Array as PropType<AiAssistantSuggestion[]>,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    refreshing: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["suggestion-click", "refresh"],
  setup(props, { emit }) {
    const handleClick = (text: string) => {
      emit("suggestion-click", text);
    };

    const onRefresh = () => {
      emit("refresh");
    };

    return {
      handleClick,
      onRefresh,
    };
  },
});
</script>

<style lang="scss" scoped>
.ai-summary-suggestion-chip {
  width: fit-content;
  justify-content: flex-start !important;
  border: 1px solid rgb(var(--v-theme-indigo-pale)) !important;
  border-radius: 4px;
}

.ai-summary-refresh-btn {
  text-transform: capitalize !important;
  letter-spacing: normal !important;
}

.icon-sync-xs::before {
  color: rgb(var(--v-theme-link));
}
</style>
